<script setup>
import { computed } from 'vue'
import { ENTITY, DEFAULT_IRO_STATS } from '../vars/mappings.js'

const props = defineProps({
	iros: {
		type: Array,
		default: undefined
	}
})

const stats = computed(() => {
	const stats = { ...DEFAULT_IRO_STATS }
	props.iros?.forEach((iro) => stats[iro.iro]++)
	return stats
})
</script>
<template>
	<div>
		<span class="secondary-text bold">IRO stats</span>
		<div class="stats-container">
			<div v-for="iroType in Object.keys(stats)" :key="iroType">
				<div class="stat">
					<component :is="ENTITY[iroType]" size="medium" />
					<div class="primary-header">{{ stats[iroType] }}</div>
				</div>
				<span class="iro-type-text primary-text">{{ iroType.replace('_', ' ') }}</span>
			</div>
		</div>
	</div>
</template>
<style scoped lang="less">
.stats-container {
	display: flex;
	width: 600px;
	justify-content: space-between;
	margin-top: @midi;
	& > * {
		display: flex;
		flex-direction: column;
		gap: @micro;
	}
	.stat {
		display: flex;
		gap: @micro;
	}
}
.iro-type-text {
	text-transform: capitalize;
	color: @gray-80;
}
</style>
